export default function getEnv (name) {
  const envMap = {
    API: process.env.API,
    BUGSNAG_API_KEY: process.env.BUGSNAG_API_KEY,
    NODE_ENV: process.env.NODE_ENV,
    GOOGLE_API: process.env.GOOGLE_API,
    PAPER_WEB: process.env.PAPER_WEB,
    GTAG_ID: process.env.GTAG_ID,
    THUMBOR_URL: process.env.THUMBOR_URL,
    ASSETS_BUCKET: process.env.ASSETS_BUCKET,
    VAT: process.env.VAT,
    get VAT_PERCENTAGE () {
      return `${this.VAT}%`
    },
    NOCO_API_URL: process.env.NOCO_API_URL,
    NOCO_API_TOKEN: process.env.NOCO_API_TOKEN,
    NOCO_KOTAKSUARA_TABLE_ID: process.env.NOCO_KOTAKSUARA_TABLE_ID,
    NOCO_FORM_URL: process.env.NOCO_FORM_URL,
    NOCO_FORM_AP_ID: process.env.NOCO_FORM_AP_ID,
    NOCO_FORM_ONGKIR_ID: process.env.NOCO_FORM_ONGKIR_ID
  }

  return window?.configs?.[name] || envMap[name]
}
